import _regeneratorRuntime from "/home/travis/build/gladly-team/tab/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/travis/build/gladly-team/tab/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/travis/build/gladly-team/tab/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/travis/build/gladly-team/tab/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { FlattenedEncrypt } from '../flattened/encrypt.js';
export var CompactEncrypt =
/*#__PURE__*/
function () {
  function CompactEncrypt(plaintext) {
    _classCallCheck(this, CompactEncrypt);

    this._flattened = new FlattenedEncrypt(plaintext);
  }

  _createClass(CompactEncrypt, [{
    key: "setContentEncryptionKey",
    value: function setContentEncryptionKey(cek) {
      this._flattened.setContentEncryptionKey(cek);

      return this;
    }
  }, {
    key: "setInitializationVector",
    value: function setInitializationVector(iv) {
      this._flattened.setInitializationVector(iv);

      return this;
    }
  }, {
    key: "setProtectedHeader",
    value: function setProtectedHeader(protectedHeader) {
      this._flattened.setProtectedHeader(protectedHeader);

      return this;
    }
  }, {
    key: "setKeyManagementParameters",
    value: function setKeyManagementParameters(parameters) {
      this._flattened.setKeyManagementParameters(parameters);

      return this;
    }
  }, {
    key: "encrypt",
    value: function () {
      var _encrypt = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(key, options) {
        var jwe;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._flattened.encrypt(key, options);

              case 2:
                jwe = _context.sent;
                return _context.abrupt("return", [jwe.protected, jwe.encrypted_key, jwe.iv, jwe.ciphertext, jwe.tag].join('.'));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function encrypt(_x, _x2) {
        return _encrypt.apply(this, arguments);
      }

      return encrypt;
    }()
  }]);

  return CompactEncrypt;
}();